shadow$provide[364] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform mat4 viewMatrix;

vec4 getCartesianPosition(vec4 position, inout vec4 stpq) {
  return viewMatrix * vec4(position.xyz, 1.0);
}
`;

};